import { render } from "./Others21Charts.vue?vue&type=template&id=9a0641b0&scoped=true"
import script from "./Others21Charts.vue?vue&type=script&lang=js"
export * from "./Others21Charts.vue?vue&type=script&lang=js"

import "./Others21Charts.vue?vue&type=style&index=0&id=9a0641b0&scoped=true&lang=scss"
import "./Others21Charts.vue?vue&type=style&index=1&id=9a0641b0&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a0641b0"]])

export default __exports__